import * as React from 'react'
import Input, { InputProps } from 'components/Input'
import { StylesConfig } from 'react-select'
export const LuggageSelect: React.FC<InputProps> = (props) => {
  const options = [...Array(6).keys()].map((code) => {
    return { label: `${code}`, value: code }
  })

  return (
    <Input.Select
      {...props}
      styles={{
        menuPortal: (styles: StylesConfig) => ({ ...styles, zIndex: 100000000 }),
      }}
      placeholder="--"
      isClearable
      options={options}
    />
  )
}

export default LuggageSelect
